import React, { useState } from "react";
import { isMobile } from 'react-device-detect';

import { HomeURL, BackendCall, DETAILS } from "../s_data/file";

// class
import '../index.css';
import AvalibleLink from "../element/AvalibleLink";
import ImageSlider from "../element/ImageSlider";
import Dialog from "../page_h/Dialog";



  
function AppDetails({ index, projectData }) {


  const [showDetails, setShowDetails] = useState(false);

  const handleToggle = () => {
    setShowDetails(prevState => !prevState);
  };



  const openAppDetails = (id) => {
    window.location.href = HomeURL + "/project_info?id=" + id;
  };





  return (
    <div className="screen_container">

      {/* One item */}
      <div className={`flex w-full ${isMobile ? `h-[85vh]` : `h-[85vh] ${index % 2 === 1 ? "flex-row-rev" : "flex-row"}`}`}>


        {/* Left */}
        <div className={`flex h-full w-full flex-col items-center justify-center ${projectData.project_type === "web" ? "w-1/3" : "w-1/2"}`}>

          {/* App icon and title */}
          <img src={projectData.app_icon} className="w-32 h-32 rounded-3xl" alt="App Icon" />
          <div className="mt-7 mb-2 text-3xl font-bold">{projectData.app_name}</div>

          {/* //project by */}
          <div className="mb-7 text-lg font-bold opacity-50">
            {
              projectData.own === "own"
                ? "OWN"
                : projectData.own === "client"
                ? "Client"
                : ""
            }
          </div>


          {/* Short description */}
          <div className={`${isMobile ? "w-full px-4" : "w-3/5"} my-3 text-lg text-center`}>
            <div className="text-white" dangerouslySetInnerHTML={{ __html: projectData.short_des.replace(/\n/g, '<br />') }} />
          </div>


          {/* Download button */}
          <div className="mt-8">
            <AvalibleLink type={projectData.avalible_on} link={projectData.p_links} name={projectData.app_name} />
          </div>


          {/* View More Details button on mobile */}
          {false ? (
            <button className="px-4 text-white rounded-lg" onClick={handleToggle} >More Details</button>
          ) : 
            <button className="px-4 text-white rounded-lg opacity-50"  onClick={() => openAppDetails(projectData?.package_name)} >More Details</button>
          }


        </div>




        {/* Right for web */}
        {(!isMobile && Array.isArray(projectData.appScreenshots) && projectData.appScreenshots.length > 0) && (
          <div className={`flex flex-col items-center justify-center ${isMobile ? "w-screen h-screen py-6" : projectData.project_type === "web" ? "w-2/3" : "w-1/2"}`}>
            <ImageSlider images={projectData.appScreenshots} />
          </div>
        )}



        {/* Trigger Dialog for mobile */}
        {showDetails && <Dialog projectData={projectData} onClose={handleToggle} />}



      </div>

      <hr className="my-4 border-t border-gray-300 dark:border-gray-600" />

    </div>
  );
}

export default AppDetails;
